import Application from '@ember/application';
import loadInitializers from 'ember-load-initializers';
import config from 'invite-sign/config/environment';
import LogRocket from 'logrocket';

import Resolver from './resolver';

// Drops the query string and hash fragment (where readable PII like visitor/host names lives); keeps the
// path. Works for relative and absolute URLs and never throws (unlike `new URL()`).
const sanitizeUrl = (url?: string | null): string => (url ?? '').split(/[?#]/)[0] ?? '';

if (config.logRocketAppId) {
  LogRocket.init(config.logRocketAppId, {
    dom: {
      inputSanitizer: true,
    },
    network: {
      responseSanitizer: (response) => {
        delete response.body;
        response.headers = {};
        return response;
      },
      requestSanitizer: (request) => {
        delete request.body;
        request.headers = {};
        request.url = sanitizeUrl(request.url);
        return request;
      },
    },
    browser: {
      urlSanitizer: (url) => sanitizeUrl(url),
    },
    shouldCaptureIP: false,
    console: { isEnabled: false },
  });
}

class App extends Application {
  modulePrefix = config.modulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);

export default App;
